export enum EColor {
	greenOne = 'greenOne',
	greenTwo = 'greenTwo',
	greenThree = 'greenThree',
	greenFour = 'greenFour',
	orangeOne = 'orangeOne',
	orangeTwo = 'orangeTwo',
	redOne = 'redOne',
	redTwo = 'redTwo',
	redThree = 'redThree',
	backgroundOne = 'backgroundOne',
	backgroundTwo = 'backgroundTwo',
	grayOne = 'grayOne',
	grayTwo = 'grayTwo',
}

export enum EFontSize {
	titleOne = 'titleOne',
	titleTwo = 'titleTwo',
	titleThree = 'titleThree',
	headingOne = 'headingOne',
	headingTwo = 'headingTwo',
	headingThree = 'headingThree',
	normal = 'normal',
	small = 'small',
	tiny = 'tiny',
}
